import get from 'lodash/get';
import { connect } from 'react-redux';
import { getFormError, submit } from 'redux-form';

import ConfirmContactInfoComponent from './ConfirmContactInfoComponent';

import { CONFIRM_CONTACT_INFO } from '../../actionConstants';

import apiClient from '../../apiClient';
import { history } from '../../store';

const form = 'ConfirmContactInfo';

const mapStateToProps = (state, ownProps) => {
  const params = new URLSearchParams(get(ownProps, 'location.search'));
  const initialValues = {};
  initialValues.token = params.get('token');
  initialValues.uid = params.get('uid');
  initialValues.id = params.get('id');
  const formError = getFormError(form)(state);
  return {
    initialValues,
    formError,
    form,
  };
};

const mapDispatchToProps = (dispatch) => ({
  remoteSubmit: (formName) => dispatch(submit(formName)),
  onSubmit: (data) =>
    dispatch({
      type: CONFIRM_CONTACT_INFO,
      isForm: true,
      payload: apiClient.contacts.confirm(data),
      callback: () => history.push('/'),
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmContactInfoComponent);
